import { useOptionalSession } from './chunk-7QYYSJGW.js';
import * as React from 'react';
import { actorDisplayName } from '@authe/fe-commons/session';
import { jsx } from 'react/jsx-runtime';

var ActorNames = React.createContext(/* @__PURE__ */ new Map());
function ActorNamesProvider({ names, children }) {
  return /* @__PURE__ */ jsx(ActorNames.Provider, { value: names, children });
}
function ActorName({ id, names, missing, className }) {
  const directory = React.useContext(ActorNames);
  const session = useOptionalSession()?.session;
  const local = names?.get(id ?? "")?.trim();
  const name = actorDisplayName(id, { self: session?.user, names: local && local !== id ? names : directory, missing });
  return /* @__PURE__ */ jsx("span", { className, title: id ? `User ID: ${id}` : void 0, children: name });
}

export { ActorName, ActorNamesProvider };
//# sourceMappingURL=chunk-MIG7XI3H.js.map
//# sourceMappingURL=chunk-MIG7XI3H.js.map